import React from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import NewUser from './pages/NewUser.jsx';
import ExistingUser from './pages/ExistingUser.jsx';
import Admin from './pages/Admin.jsx';
import Header from './components/Header.jsx';
import Footer from './components/Footer.jsx';
import Questions from './pages/Questions.jsx';
import ResumeScan from './pages/ResumeScan.jsx';
import TAGScan from './pages/TAGscreening.jsx';
import LiveAssessment from './pages/LiveAssessment.jsx';
import Dashboard from './pages/Dashboard.jsx';
import InternalUser from './pages/InternalUser.jsx';
import Login from './pages/Login.jsx';
import ProtectedRoute from './auth/ProtectedRoute.jsx';
import '../src/styles/style.css';
import welcomeImage from '../src/assets/image/welcome.jpg';

function App() {
  const navigate = useNavigate();

  return (
    <Routes>
      {/* Public route — no header/footer */}
      <Route path="/login" element={<Login />} />

      {/* All other routes are protected */}
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <div>
              <Header onNavigate={navigate} />
              <main>
                <div className="content">
                  <Routes>
                    <Route path="/new-user" element={<NewUser />} />
                    <Route path="/internal-user" element={<InternalUser />} />
                    <Route path="/live-assessment" element={<LiveAssessment />} />
                    <Route path="/existing-user" element={<ExistingUser />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="/resume-scan" element={<ResumeScan />} />
                    <Route path="/tag-screening" element={<TAGScan />} />
                    <Route path="/sample-questions" element={<Questions />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route
                      path="/"
                      element={
                        <div>
                          <img
                            src={welcomeImage}
                            alt="Welcome to iAssess"
                            className="welcome-image"
                          />
                        </div>
                      }
                    />
                  </Routes>
                </div>
              </main>
              <Footer />
            </div>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;
